import { useSelector } from 'react-redux';

import { toObject } from '../utils/common.utils';

import type { Pipe, PipeMap } from '../types/pipes.types';
import type { RootState } from '../types/state.types';

export const useGetCurrentPipe = (pipeId: string) => {
  const userPipes = useSelector((state: RootState) => state.pipes);
  const internalPipes = useSelector((state: RootState) => state.internalEntities.pipes);
  const internalPipesObject: PipeMap = toObject<Pipe>(internalPipes);

  const currentPipe = userPipes[pipeId] ?? internalPipesObject[pipeId];

  return currentPipe;
};
